import { render, staticRenderFns } from "./BlockTitle.vue?vue&type=template&id=d3c550ee&"
import script from "./BlockTitle.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BlockTitle.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3c550ee')) {
      api.createRecord('d3c550ee', component.options)
    } else {
      api.reload('d3c550ee', component.options)
    }
    module.hot.accept("./BlockTitle.vue?vue&type=template&id=d3c550ee&", function () {
      api.rerender('d3c550ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/pressa/components/BlockTitle.vue"
export default component.exports